import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const MeetOurTeam = ({ data }) => {
  return (
    <section className={`section-center ${s.our_team}`}>
      <Container>
        <h2 className="title fw-bold">{data?.title || ""}</h2>
        <div className={s.team_container}>
          {data?.team.map((items, idx) => {
            return (
              <React.Fragment key={idx}>
                {idx % 2 === 0 ? (
                  <Row className={`align-items-center ${s.arthur}`}>
                    <Col md={6}>
                      <img
                        loading="lazy"
                        src={items?.person_image.url}
                        alt="image"
                        height="100%"
                      />
                    </Col>
                    <Col md={6} className="text-md-start">
                      <h3 className="heading fw-bold">
                        {items?.name || ""} {items?.position ? "-" : ""}{" "}
                        {items?.position || ""}
                      </h3>
                      <div className={`${secondaryFont} paragraph`}>
                        <PrismicRichText field={items?.description || []} />
                      </div>
                      <img
                        loading="lazy"
                        className={s.signature}
                        src={items.signature.url}
                        alt={items.signature.alt || "signature"}
                        height="100%"
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row className={`align-items-center ${s.albert}`}>
                    <Col md={6} className="text-md-end">
                      <h3 className="heading fw-bold">
                        {items?.name || ""} {items?.position ? "-" : ""}{" "}
                        {items?.position || ""}
                      </h3>
                      <div className={`${secondaryFont} paragraph`}>
                        <PrismicRichText field={items?.description || []} />
                      </div>
                      <img
                        loading="lazy"
                        className={s.signature}
                        src={items.signature.url}
                        alt={items.signature.alt || "signature"}
                        height="100%"
                      />
                    </Col>
                    <Col md={6}>
                      <img
                        loading="lazy"
                        src={items?.person_image.url}
                        alt="image"
                        height="100%"
                        className={s.person_image}
                      />
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default MeetOurTeam;
